Whether this choice was explicitly selected as a preference.

When authoring a new questionnaire based on existing questions,
response choice selections may be pre-filled from this indicator.

- For a custom question, this always matches `preferredIndicator`.

- For a library question, this is set for bounding preferences only.

  For example, a library question may define choices 1–5,
  and require a minimum and maximum to be selected as a range preference.
  Selecting the range 2–4 will set `preferredIndicator` for choices 2, 3, and 4,
  and `selectedIndicator` for bounding choices 2 and 4.

This is not displayed to the candidate.
